// Canonical item keys — mirrors backend/core/identifiers.py (keep in sync).
//   package + "<ecosystem>:<name>"   e.g. package + npm:lodash
// The API also accepts the aliases npm_package / pypi_package, but the UI sends canonical keys.

export const CHECK_KINDS = [
  { value: "npm", label: "npm package", hint: "lodash or @scope/name" },
  { value: "pypi", label: "PyPI package", hint: "requests" },
  { value: "mcp_server", label: "MCP server", hint: "io.example/server-name" },
  { value: "x402_endpoint", label: "x402 endpoint", hint: "https://…" },
  { value: "manual", label: "Other (manual)", hint: "" },
];

const PYPI_SEP = /[-_.]+/g;

export function normalisePackageName(ecosystem, name) {
  const n = (name || "").trim();
  return ecosystem === "pypi" ? n.replace(PYPI_SEP, "-").toLowerCase() : n.toLowerCase();
}

// kind: one of CHECK_KINDS values, or an API alias (npm_package / pypi_package / package).
export function toCanonical(kind, identifier) {
  const raw = (identifier || "").trim();
  const alias = { npm_package: "npm", pypi_package: "pypi" };
  const eco = alias[kind] || (kind === "npm" || kind === "pypi" ? kind : null);
  if (eco) {
    const bare = raw.toLowerCase().startsWith(`${eco}:`) ? raw.slice(eco.length + 1) : raw;
    return { type: "package", identifier: `${eco}:${normalisePackageName(eco, bare)}` };
  }
  if (kind === "package") {
    const i = raw.indexOf(":");
    const prefix = i > 0 ? raw.slice(0, i).toLowerCase() : "";
    if (prefix === "npm" || prefix === "pypi") {
      return { type: "package", identifier: `${prefix}:${normalisePackageName(prefix, raw.slice(i + 1))}` };
    }
    return { type: "package", identifier: raw.toLowerCase() };
  }
  if (/^https?:\/\//.test(raw)) return { type: kind, identifier: raw.replace(/\/+$/, "") };
  return { type: kind, identifier: raw.toLowerCase().replace(/\/+$/, "") };
}
